export const name = 'Administration';
